<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">About</h4>
    <div mat-dialog-content class="dialog-content">
        <div class="col-12 about-container">
            <img class="img-fluid mt-1" [src]="logoLogin" [alt]="logoAlt">
            <div class="col-12 p-1 mt-2 text-center">
                <p>
                    {{ accountInfo?.isSuperUser === true ? '(Dashboard) Version' :
                    accountInfo?.isSuperUser === false ? '(Personal) Version' : 'Version' }}<br>
                    <span id="version">
                        1.39.30
                    </span>
                </p>
            </div>
            <div class="col-12 p-1 mt-2 text-center">
                <p><span class="copyright-box">Copyright&nbsp;<i class="material-icons">copyright</i></span>&nbsp;2024,
                    RAMPIERE</p>
            </div>
            <div class="col-12 p-1 mt-2 text-center">
                <p>For more information about this application, just visit <br>
                    <a href="https://rampiere.com" target="_blank">RAMPIERE</a>
                </p>
            </div>
        </div>
    </div>
</div>